module.exports = __webpack_public_path__ + "static/cag8-5d6b647204cd711056a9616a2696cc98.png";